module.exports = __webpack_public_path__ + "media/images/lb/607-9ecda4044410c693ff23ff7e18a5e70a.svg";